// extracted by mini-css-extract-plugin
module.exports = {"socialNetworks":"SocialNetworks_socialNetworks__a7GFp","socialNetworks__link":"SocialNetworks_socialNetworks__link__E5pB4"};